import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

export default function ContactCTA() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section ref={ref} className="bg-charcoal py-24">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="font-serif text-5xl md:text-6xl text-white mb-12"
        >
          Markan için güçlü bir plan çıkaralım.
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="flex items-center justify-center"
        >
          <button
            onClick={scrollToContact}
            className="bg-white text-charcoal px-8 py-4 rounded-full font-sans font-medium text-sm hover:bg-white/90 transition-all cursor-pointer whitespace-nowrap"
          >
            Brief Gönder
          </button>
        </motion.div>
      </div>
    </section>
  );
}
